import React from 'react';
import { Key } from 'ts-key-enum';
import { useCloseViewerCallback, useDeleteFileCallback, useEnterFullScreenCallback, } from 'js/file_viewer/api/navigation';
import { useActiveEditorId } from 'js/file_viewer/api/ui';
import { useFileViewerContext } from 'js/file_viewer/contexts/file_viewer';
import { isDeleteFileModalOpenAtom, isSlideshowAtom } from 'js/file_viewer/core/atoms/ui/general';
import { isCurrentPreviewZoomedAtom } from 'js/file_viewer/core/atoms/ui/zoom';
import { useFileViewerAtomValue } from 'js/file_viewer/core/atoms/use_atom';
import { UserActionContext, UserAction } from 'js/file_viewer/core/logging/constants';
import { useRootPreviewKey } from 'js/file_viewer/hooks/selectors';
import { getKeyboardBinding, getDeleteFileBindings, useFileFlippingBindings, } from 'js/file_viewer/keyboard/bindings';
import { KeyboardBindingConnector } from 'js/file_viewer/keyboard/keyboard_connector';
export const PreviewKeyboardBindings = React.memo((props) => {
    const { isDeleteEnabled, isFileFlippingEnabled, enableFullscreen, fileIndex, collectionFileCount, } = props;
    const { logUserAction } = useFileViewerContext();
    const isDeleteFileModalOpen = useFileViewerAtomValue(isDeleteFileModalOpenAtom);
    const isPreviewZoomed = useFileViewerAtomValue(isCurrentPreviewZoomedAtom);
    const isSlideshow = useFileViewerAtomValue(isSlideshowAtom);
    const previewKey = useRootPreviewKey();
    const isEditMode = !!useActiveEditorId();
    const enterFullScreenCallback = useEnterFullScreenCallback();
    const fullScreenBinding = enableFullscreen && !isEditMode
        ? getKeyboardBinding({
            callback: () => enterFullScreenCallback({ actionContext: UserActionContext.Keyboard }),
            key: 'f',
        })
        : null;
    const closeViewer = useCloseViewerCallback();
    const closeBinding = getKeyboardBinding({
        key: Key.Escape,
        callback: () => {
            closeViewer(UserActionContext.Keyboard);
        },
    });
    const deleteFile = useDeleteFileCallback();
    const deleteBinding = previewKey &&
        getDeleteFileBindings((key) => {
            logUserAction(UserAction.Delete, UserActionContext.Keyboard);
            deleteFile(UserActionContext.Keyboard, key === Key.Delete ? 'delete' : 'backspace');
        });
    const fileFlippingBindings = useFileFlippingBindings({
        requireCommandKey: isPreviewZoomed,
        fileIndex: fileIndex,
        collectionFileCount: collectionFileCount,
        isSlideshow,
    });
    const keyboardBindings = [];
    if (fullScreenBinding) {
        keyboardBindings.push(fullScreenBinding);
    }
    if (isFileFlippingEnabled && !isDeleteFileModalOpen) {
        keyboardBindings.push(...fileFlippingBindings);
        keyboardBindings.push(closeBinding);
    }
    if (isDeleteEnabled && !isDeleteFileModalOpen && deleteBinding) {
        keyboardBindings.push(...deleteBinding);
    }
    return React.createElement(KeyboardBindingConnector, { name: "app", keyboardBindings: keyboardBindings });
});
PreviewKeyboardBindings.displayName = "PreviewKeyboardBindings"
//# sourceMappingURL=preview_keyboard_bindings.preenvesnextjs.map
